(function ($) {
    $(document).ready(function () {
        quickView();
    });
     
    function quickView() {
        var productJSON = {};
        var sold_out_text = 'Sold Out';
        // quick view button click event
        $('body').on('click', ".quick-view", function () {
            let shopOnButton = "", shopOnLink = "";
            if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
            var product_handle = $(this).data('handle');
            var productUrl = $(this).data('url');
            $('#quick-view').addClass(product_handle);

            // ajax call to init content
            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                productJSON = product;

                jQuery.ajax({url: '/admin/products/' + productJSON.id + '/metafields.json'}).done(function(data) {
                    data.metafields.forEach(field => {
                        if(field.namespace == 'pdp' && field.key == 'excerpt') {
                            $('.qv-product-description').html(field.value);
                        } else if(field.namespace == 'custom' && field.key == 'shop_on_button') {
                            shopOnButton = field.value;
                        } else if(field.namespace == 'custom' && field.key == 'shop_on_link') {
                            shopOnLink = field.value;
                        }
                        if (shopOnButton && shopOnLink) {
                            $(".qv-add-to-cart div").hide();
                        }
                    })
                })

                var title = product.title;
                var type = product.type;
                var price = 0;
                var original_price = 0;
                var desc = product.description;
                var images = product.images.reverse();
                var variants = product.variants;
                var options = product.options;
                var url = productUrl ? productUrl : '/products/' + product_handle;

                if (product.type == 'Course') {
                    sold_out_text = 'Coming Soon';
                    $(".qv-add-to-cart .quantity").hide();
                } else {
                    sold_out_text = 'Sold Out';
                    $(".qv-add-to-cart .quantity").show();
                }

                $('.qv-product-title').text(title);
                $('.view-product').attr('href', url);
                var imageCount = $(images).length;
                $(images).each(function (i, image) {
                    var image_embed = '<div class="swiper-slide"><img src="' + image + '"></div>';
                    image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
                    $('.qv-product-images .swiper-wrapper').prepend(image_embed);
                    $('.qv-product-thumnails .swiper-wrapper').prepend(image_embed);
                });

                // initialize swiper
                initSwiper();

                $(options).each(function (i, option) {
                    var opt = option.name;

                    if (opt == "Title") return;

                    var selectClass = '.option.' + opt.toLowerCase();
                    $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option-label">' + opt + ': </span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
                    $(option.values).each(function (i, value) {
                        $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
                    });
                    if (option.name == "Size") {
                        $(option.values).each(function (i, value) {
                            let buttonClass = '';
                            if (i == 0) {
                                buttonClass = ' selected';
                            }
                            let buttonHtml = '<div class="option-select-button' + buttonClass + '" data-value="'+ value + '"><span value="' + value + '">' 
                                + value + '</span></div>';
                            $('.qv-product-options-buttons').append(buttonHtml);
                        });
                    }
                });
                var variantInfo = $('#qv_variant_info');
                $(product.variants).each(function (i, v) {
                    if (v.available == false) {
                        $('.qv-add-button').prop('disabled', true).val(sold_out_text);
                        $('.qv-add-to-cart').hide();
                        $('.qv-product-price').text(sold_out_text).show();
                        return true
                    } else {
                        price = parseFloat(v.price / 100).toFixed(2);
                        original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                        $('.qv-product-price').text('$' + price);
                        $('.qv-subtotal').text('$' + price).attr('data-price', price);                   
                        if (original_price > 0) {
                            $('.qv-product-original-price').text('$' + original_price).show();
                        } else {
                            $('.qv-product-original-price').hide();
                        }
                    $('select.option-0').val(v.option1);
                    $('select.option-1').val(v.option2);
                    $('select.option-2').val(v.option3);
                    return false
                    }
                });
                initOptionButtons();
                initQtyButtons();

                // update subtotal
                $("#qv-quantity").on("change", function() {
                    updateSubtotal();
                })
            });// end of ajax call
            
            // option select change event
            $(document).on("change", "#quick-view select", function () {
                var selectedOptions = '';
                $('#quick-view select').each(function (i) {
                    if (selectedOptions == '') {
                        selectedOptions = $(this).val();
                    } else {
                        selectedOptions = selectedOptions + ' / ' + $(this).val();
                    }
                });

                $(productJSON.variants).each(function (i, v) {
                    if (v.title == selectedOptions) {
                       var price = parseFloat(v.price / 100).toFixed(2);
                       var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                       var v_qty = v.inventory_quantity;
                       var v_inv = v.inventory_management;
                       $('.qv-product-price').text('$' + price);
                       $('.qv-subtotal').attr('data-price', price);
                       $('.qv-product-original-price').text('$' + original_price);

                       updateSubtotal();
                       if (v_inv == null) {
                            $('.qv-add-button').prop('disabled', false).val('Add to Bag');
                        } else {
                            if (v.inventory_quantity < 1) {
                               $('.qv-add-button').prop('disabled', true).val(sold_out_text);
                            } else {
                               $('.qv-add-button').prop('disabled', false).val('Add to Bag');
                            }
                        }
                    }
                });
            }); // endof select change event            

            // initialize fancybox
            initFancybox();

        }); // end of quick view button click event 
    };

    function initFancybox() {
        $.fancybox({
            href: '#quick-view',
            maxWidth: 900,
            //maxHeight: 800,
            fitToView: true,
            width: '95%',
            height: '60%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',

            'beforeLoad': function () {
                // add to cart
                var product_handle = $('#quick-view').attr('class');
                $(document).off('click', '.qv-add-button');
                $(document).on("click", ".qv-add-button", function () {
                    var qty = $('.qv-quantity').val();
                    var selectedOptions = '';
                    var var_id = '';
                    $('#quick-view select').each(function (i) {
                        if (selectedOptions == '') {
                            selectedOptions = $(this).val();
                        } else {
                            selectedOptions = selectedOptions + ' / ' + $(this).val();
                        }
                    });
                    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                        if (product.variants.length == 1) {
                            var_id = product.variants[0].id;
                            processCart();
                        } else {
                            $(product.variants).each(function (i, v) {
                                if (v.title == selectedOptions ) {
                                   var_id = v.id;
                                   processCart();
                                }
                            });
                        }
                     });
                    function processCart() {
                        $('.qv-add-to-cart-response').removeClass('error').removeClass('success').html('');
                        jQuery.post('/cart/add.js', {
                            quantity: qty,
                            id: var_id
                        },null,"json").done(function () {
                            $('.qv-add-to-cart-response').removeClass('error').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
                        })
                        .fail(function ($xhr) {
                            var data = $xhr.responseJSON;
                            $('.qv-add-to-cart-response').removeClass('success').addClass('error').html('<span><b>ERROR: </b>' + data.description);
                        });
                    }
                });
                $('.fancybox-wrap').css('overflow', 'hidden !important');            

            },

            'afterShow': function () {
               $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
                 $('.qv-product-images').addClass('loaded');
               });
            },

            'afterClose': function () {
               $('#quick-view').removeClass().empty();
            }
        });
    }

    function initSwiper() {    
        var swiper = new Swiper(".qv-swiper-product-thumbnails", {
            spaceBetween: 25,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var swiper2 = new Swiper(".qv-swiper-product-main", {
            loop: false,
            spaceBetween: 0,

            // If we need pagination
            pagination: {
                el: ".swiper-pagination"
            },

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: swiper,
            },
        });
    }

    function initOptionButtons() {
        // In order to match the style for size options, add extra dives to function as the select button
        $(".option-select-button").on('click', function(){
            let sizeSelect = $('select.size');
            let value = $(this).data('value');
                sizeSelect.val(value);
                sizeSelect.trigger('change');
                $(".option-select-button").removeClass('selected');
                $(this).addClass('selected');
        });   
    }

    function initQtyButtons() {
        let qtyInput = $('#qv-quantity');
        $('.qv-content .qty-decrease').on('click', function() {
            decreaseValue(qtyInput);
        });
        $('.qv-content .qty-increase').on('click', function() {
            increaseValue(qtyInput);
        })
    }

    function increaseValue(qtyInput) {
        value = parseInt(qtyInput.val(), 10);

        value = isNaN(value) ? 0 : value;
        value++;
        qtyInput.val(value).trigger('change');
    }

    function decreaseValue(qtyInput) {
        value = parseInt(qtyInput.val(), 10);

        value = isNaN(value) ? 1 : value;
        if (value > 1) value--;
        qtyInput.val(value).trigger('change');
    }

    function updateSubtotal() {
        let subtotalDiv = $(".qv-subtotal");
        let price = parseFloat(subtotalDiv.attr('data-price'));
        let qty = parseInt($('#qv-quantity').val());
        let subtotal = (qty * price).toFixed(2);
        subtotalDiv.text("$" + subtotal);
    }
 
})(jQuery);